const host = typeof window !== 'undefined' ? window.location.hostname : ''
const isDevDomain = host === 'localhost' || host.includes('-dev.oujat.com') || host === 'dev.oujat.com'

export const API_BASE_URL = isDevDomain ? 'https://api-dev.oujat.com' : 'https://api.oujat.com'
const DEV_MEDIA_URL = 'https://oujat-storage.s3.us-east-2.amazonaws.com'
const PROD_MEDIA_URL = 'https://oujat-storage-prod.s3.us-east-2.amazonaws.com'
export const MEDIA_URL = (process.env.REACT_APP_MEDIA_URL || (isDevDomain ? DEV_MEDIA_URL : PROD_MEDIA_URL)).replace(
  /\/$/,
  ''
)
export const SOCKET_URL = API_BASE_URL

export const ApiEndPoints = {
  BASE_URL: API_BASE_URL,
  SOCKET_URL: SOCKET_URL,
  AUTH: {
    register: `${API_BASE_URL}/api/v1/auth/register`,
    agentApplicationDraft: `${API_BASE_URL}/api/v1/auth/agent-application`,
    agentApplicationUpdate: `${API_BASE_URL}/api/v1/auth/agent-application`,
    agentApplicationResume: `${API_BASE_URL}/api/v1/auth/agent-application/resume`,
    agentApplicationSubmit: `${API_BASE_URL}/api/v1/auth/agent-application/submit`,
    agentApplicationResendLink: `${API_BASE_URL}/api/v1/auth/agent-application/resend-link`,
    login: `${API_BASE_URL}/api/v1/auth/login/agent`,
    loginwithgoogle: `${API_BASE_URL}/api/v1/social/google/signin/agent`,
    logout: `${API_BASE_URL}/api/v1/auth/logout`,
    me: `${API_BASE_URL}/api/v1/auth/me`,
    forgot_password: `${API_BASE_URL}/api/v1/auth/forgot/password`,
    verify_otp: `${API_BASE_URL}/api/v1/auth/verify/otp`,
    resend_otp: type => `${API_BASE_URL}/api/v1/auth/resend/otp/${type}`,
    reset_password: `${API_BASE_URL}/api/v1/auth/reset/password`,
    set_password: `${API_BASE_URL}/api/v1/auth/agent/password/setup`,
    change_password: `${API_BASE_URL}/api/v1/dealer/auth/change-password`,
    change_email: `${API_BASE_URL}/api/v1/dealer/auth/change-email`,
    change_email_verify_otp: `${API_BASE_URL}/api/v1/dealer/auth/change-email-verify-otp`,
    profileImage: `${API_BASE_URL}/api/v1/auth/profile/image`,
    profile: `${API_BASE_URL}/api/v1/auth/profile`,
    resubmitDocument: `${API_BASE_URL}/api/v1/auth/profile/document/resubmit`,
    userProtection: `${API_BASE_URL}/api/v1/protection/renew`
  },
  DASHBOARD: {
    count: `${API_BASE_URL}/api/v1/dashboard/agent`,
    revenueChart: `${API_BASE_URL}/api/v1/dashboard/agent/revenue/chart`,
    growthChart: `${API_BASE_URL}/api/v1/dashboard/agent/customer-growth/chart`
  },
  CARGO: {
    list: `${API_BASE_URL}/api/v1/misc/category/cargo_type`
  },
  QMS: {
    list: `${API_BASE_URL}/api/v1/qms/all/agent`,
    qmsbyid: id => `${API_BASE_URL}/api/v1/qms/agent/${id}`,
    tabcount: `${API_BASE_URL}/api/v1/qms/tab-counts/agent`
  },
  SERVICES: {
    list: `${API_BASE_URL}/api/v1/service`,
    add: `${API_BASE_URL}/api/v1/service`,
    countrylist: `${API_BASE_URL}/api/v1/service/region/countries/:region`,
    update: id => `${API_BASE_URL}/api/v1/service/${id}`,
    listbyid: id => `${API_BASE_URL}/api/v1/service/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/service/${id}`,
    status: id => `${API_BASE_URL}/api/v1/service/status/${id}`
  },
  GET_REGION: {
    country: `${API_BASE_URL}/api/v1/utils/common/countries`,
    state: `${API_BASE_URL}/api/v1/utils/common/states`,
    city: `${API_BASE_URL}/api/v1/utils/common/cities`
  },
  QUOTATION: {
    add: `${API_BASE_URL}/api/v1/quotation`,
    list: `${API_BASE_URL}/api/v1/quotation`,
    listbyid: id => `${API_BASE_URL}/api/v1/quotation/${id}`,
    update: id => `${API_BASE_URL}/api/v1/quotation/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/quotation/${id}`
  },
  MOBILE_MONEY: {
    accounts: `${API_BASE_URL}/api/v1/agent/mobile-money/accounts`,
    account: id => `${API_BASE_URL}/api/v1/agent/mobile-money/accounts/${id}`,
    pawapayConfig: `${API_BASE_URL}/api/v1/agent/mobile-money/pawapay-config`,
    preferences: `${API_BASE_URL}/api/v1/agent/mobile-money/preferences`
  },
  STOREFRONT: {
    add: `${API_BASE_URL}/api/v1/storefront`,
    list: `${API_BASE_URL}/api/v1/storefront`,
    listbyid: id => `${API_BASE_URL}/api/v1/storefront/${id}`,
    store: `${API_BASE_URL}/api/v1/storefront/update`,
    document: `${API_BASE_URL}/api/v1/storefront/documents`,
    gallery: `${API_BASE_URL}/api/v1/storefront/gallery`,
    delete: id => `${API_BASE_URL}/api/v1/storefront/category/${id}`,
    address: id => `${API_BASE_URL}/api/v1/storefront/address/${id}`,
    addaddress: `${API_BASE_URL}/api/v1/storefront/add/address`,
    review: id => `${API_BASE_URL}/api/v1/misc/storefront/reviews/${id}`
  },
  TEAM: {
    list: `${API_BASE_URL}/api/v1/sub-user`,
    add: `${API_BASE_URL}/api/v1/sub-user`,
    update: id => `${API_BASE_URL}/api/v1/sub-user/${id}`,
    listbyid: id => `${API_BASE_URL}/api/v1/sub-user/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/sub-user/${id}`
  },
  ROLE: {
    list: `${API_BASE_URL}/api/v1/role`,
    add: `${API_BASE_URL}/api/v1/role`,
    update: id => `${API_BASE_URL}/api/v1/role/${id}`,
    listbyid: id => `${API_BASE_URL}/api/v1/role/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/role/${id}`,
    count: `${API_BASE_URL}/api/v1/sub-user/card/data`,
    listById: id => `${API_BASE_URL}/api/v1/role/${id}`
  },
  NOTIFICATION: {
    list: `${API_BASE_URL}/api/v1/notification/user`,
    sent_fcm_token: `${API_BASE_URL}/api/v1/notification/token/user`,
    delete: id => `${API_BASE_URL}/api/v1/notification/user`,
    markAsRead: id => `${API_BASE_URL}/api/v1/notification/user`
  },
  CATEGORY: {
    list: type => `${API_BASE_URL}/api/v1/misc/category/${type}`
  },
  Chat: {
    add: userId => `${API_BASE_URL}/api/v1/chat/conversation/start/${userId}`,
    conversation: conversationId => `${API_BASE_URL}/api/v1/chat/conversation/${conversationId}`,
    messages: conversationId => `${API_BASE_URL}/api/v1/chat/messages/${conversationId}`,
    memberList: `${API_BASE_URL}/api/v1/chat/member/list`,
    addMember: conversationId => `${API_BASE_URL}/api/v1/chat/add/member/${conversationId}`,
    removeMember: conversationId => `${API_BASE_URL}/api/v1/chat/remove/member/${conversationId}`,
    adminUserConversation: groupType => `${API_BASE_URL}/api/v1/chat/conversation/admin-user/${groupType}`
  },
  ORDER: {
    list: `${API_BASE_URL}/api/v1/order/all/agent`,
    listbyid: id => `${API_BASE_URL}/api/v1/order/${id}`,
    cancelorder: id => `${API_BASE_URL}/api/v1/order/cancel/${id}`,
    makePayment: `${API_BASE_URL}/api/v1/payment/options`,
    keeporder: id => `${API_BASE_URL}/api/v1/order/keep/pre-cost/${id}`,
    postAssessmentCost: id => `${API_BASE_URL}/api/v1/order/post/assessment/${id}`,
    shipmentArrived: id => `${API_BASE_URL}/api/v1/order/shipment/arrived/${id}`,
    shipmentDelivered: id => `${API_BASE_URL}/api/v1/order/shipment/delivered/${id}`,
    addCharges: id => `${API_BASE_URL}/api/v1/order/processing/charges/${id}`,
    fullRefund: id => `${API_BASE_URL}/api/v1/order/refund/processing-charge-timeout/${id}`,
    completeOrderInvoice: id => `${API_BASE_URL}/api/v1/order/download/invoice/${id}`
  },
  Wallet: {
    get: `${API_BASE_URL}/api/v1/wallet/`,
    getTransaction: `${API_BASE_URL}/api/v1/transaction`
  },
  addMoney: {
    paypal: `${API_BASE_URL}/api/v1/wallet/create/paypal/checkout-session`,
    stripe: `${API_BASE_URL}/api/v1/wallet/create/stripe/checkout-session`
  },
  DisputeCenter: {
    list: `${API_BASE_URL}/api/v1/dispute`,
    listbyid: id => `${API_BASE_URL}/api/v1/dispute/${id}`,
    orderlist: `${API_BASE_URL}/api/v1/order/list/dispute`,
    createdispute: `${API_BASE_URL}/api/v1/dispute`
  },
  AddressBook: {
    list: `${API_BASE_URL}/api/v1/addressbook`,
    listbyid: id => `${API_BASE_URL}/api/v1/addressbook/${id}`,
    personalcontact: `${API_BASE_URL}/api/v1/addressbook`,
    businesscontact: `${API_BASE_URL}/api/v1/addressbook`,
    editpersonalcontact: id => `${API_BASE_URL}/api/v1/addressbook/${id}`,
    editbusinesscontact: id => `${API_BASE_URL}/api/v1/addressbook/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/addressbook/${id}`,
    pastorder: role => `${API_BASE_URL}/api/v1/order/past/list/${role}`,
    recentchats: `${API_BASE_URL}/api/v1/addressbook/past/chats`,
    downloadpersonalcontact: `${API_BASE_URL}/api/v1/addressbook/personal/contact/template`,
    downloadbusinesscontact: `${API_BASE_URL}/api/v1/addressbook/business/contact/template`,
    uploadpersonalcontact: `${API_BASE_URL}/api/v1/addressbook/upload/personal-contact`,
    uploadbusinesscontact: `${API_BASE_URL}/api/v1/addressbook/upload/business-contact`
  },
  BADGE: {
    details: `${API_BASE_URL}/api/v1/badge/details`,
    acceptCondition: `${API_BASE_URL}/api/v1/badge/accept-condition`
  }
}
